import React, { useState } from "react";
import { Button, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { sendSalesHandoff } from "./salesHandoffService";
import { trackProspectProductMilestone } from "util/prospectTrialAnalytics";
import styles from "./intentInsights/intentInsights.module.scss";

export default function SalesHandoffModal({
  open,
  onClose,
  botId,
  sessionId,
  visitorEmail,
  intent,
  friction,
  summary,
  onSuccess,
}) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSend = async () => {
    setLoading(true);
    setError("");
    try {
      await sendSalesHandoff(botId, sessionId, {
        email: visitorEmail,
        intent,
        friction,
        summary,
        destination: "sales_team",
      });
      trackProspectProductMilestone("first_sales_handoff", { bot_id: botId, session_id: sessionId });
      if (onSuccess) onSuccess();
      onClose();
    } catch (_) {
      setError(t("sonic_prospect.sales_handoff.error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={t("sonic_prospect.sales_handoff.title")}
      footer={[
        <Button key="cancel" onClick={onClose}>
          {t("common.cancel", "Cancel")}
        </Button>,
        <Button key="send" type="primary" loading={loading} onClick={handleSend}>
          {t("sonic_prospect.sales_handoff.send")}
        </Button>,
      ]}
    >
      <div className={styles.handoffModalBody}>
        <p>
          <strong>{t("sonic_prospect.sales_handoff.visitor")}</strong>
          <br />
          {visitorEmail || t("sonic_prospect.sales_handoff.visitor_unknown")}
        </p>
        <p>
          <strong>{t("sonic_prospect.sales_handoff.intent")}</strong>
          <br />
          {intent || "—"}
        </p>
        <p>
          <strong>{t("sonic_prospect.sales_handoff.friction")}</strong>
          <br />
          {friction || "—"}
        </p>
        <p>
          <strong>{t("sonic_prospect.sales_handoff.summary")}</strong>
          <br />
          {summary || "—"}
        </p>
        {error ? <p className={styles.handoffError}>{error}</p> : null}
        <p className={styles.handoffNote}>{t("sonic_prospect.sales_handoff.note")}</p>
      </div>
    </Modal>
  );
}
